import {
  Row,
  Card,
  Typography,
  Button,
} from "../../../components/common/utils/antd-imports/AntdImports";
import { ReactComponent as SuccessGreenIcon } from "../../../assests/success-green-icon.svg";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_LEAD_SUCCESS } from "../../../store/slices/auth/BillboardEnquirySlice";
const Text = Typography;

function LeadGenerationSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLeadSuccess } = useSelector((state) => state.billboardEnquiry);
  useEffect(() => {
    if (!isLeadSuccess) {
      navigate("/", { replace: true });
    }
  });
  useEffect(() => {
    return () => {
      dispatch(CLEAR_LEAD_SUCCESS());
    };
  }, [dispatch]);
  return (
    <>
      <div className="lead-success-container">
        <Card className="form-generation-card ">
          <Row className="success-card-lead-row">
            <SuccessGreenIcon className="success-green-icon" />

            <Text className="tell-us-text">
              Thanks, we’ve received your request
            </Text>
            <Row className="thanks-your-info-row">
              <Text className="this-is-information-text">
                Your information has been successfully
              </Text>
              <Text className="this-is-information-text">submitted.</Text>
            </Row>
            <Row className="success-back-to-home-row">
              <Button
                type="primary"
                htmlType="submit"
                className="advertise-form-submit-button billboard-button-2"
                onClick={() => {
                  navigate("/");
                }}
              >
                Back to home
              </Button>
              <Text className="our-team-get-back-text">
                Our team will get back to you within 24 hours.
              </Text>
            </Row>
          </Row>
        </Card>
      </div>
    </>
  );
}
export default LeadGenerationSuccess;
